var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPhoto = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 7.75C0 5.67893 1.67893 4 3.75 4H4.63654L5.66201 2.38903C6.21272 1.52388 7.16722 1 8.19277 1H11.8072C12.8328 1 13.7873 1.52388 14.338 2.38903L15.3635 4H16.25C18.3211 4 20 5.67893 20 7.75V15.25C20 17.3211 18.3211 19 16.25 19H3.75C1.67893 19 0 17.3211 0 15.25V7.75ZM14 11C14 13.2091 12.2091 15 10 15C7.79086 15 6 13.2091 6 11C6 8.79086 7.79086 7 10 7C12.2091 7 14 8.79086 14 11Z",
  fill: "white"
})));
export { SvgPhoto as ReactComponent };